/* Remy carousel: arrow buttons for a native scroll-snap track, plus "Read the full review" toggles. No dependencies. */
(function () {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    var track = root.querySelector('[data-track]');
    var prev = root.querySelector('[data-dir="-1"]');
    var next = root.querySelector('[data-dir="1"]');

    function step() {
      var first = track.children[0];
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return first ? first.getBoundingClientRect().width + gap : track.clientWidth;
    }
    function sync() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
      root.querySelector('.remy-carousel__nav').hidden = max <= 0;
    }
    [prev, next].forEach(function (btn) {
      if (!btn) return;
      btn.addEventListener('click', function () {
        track.scrollBy({ left: step() * Number(btn.dataset.dir), behavior: 'smooth' });
      });
    });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    window.addEventListener('load', sync);
    sync();

    // Long reviews: clamp to 5 lines with a toggle, only when they actually overflow.
    root.querySelectorAll('[data-clamp]').forEach(function (quote) {
      var btn = quote.parentElement.querySelector('[data-more]');
      quote.classList.add('is-clamped');
      if (quote.scrollHeight - quote.clientHeight > 4) {
        btn.hidden = false;
        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', function () {
          var open = quote.classList.toggle('is-clamped') === false;
          btn.setAttribute('aria-expanded', String(open));
          btn.textContent = open ? 'Show less' : 'Read the full review';
        });
      } else {
        quote.classList.remove('is-clamped');
      }
    });
  }
  function initAll() { document.querySelectorAll('[data-remy-carousel]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
